import styled from "@emotion/styled";
import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import { ScrollUpIcon } from "ui";

const StyledIconWrapper = styled(Button)`
`
export const useScrollMinMax = (minOffset: number = 0, maxOffset: number = 0, showInDefault: boolean = true) => {

    const [isInRange, setIsInRange] = useState(showInDefault);

    useEffect(() => {
        const handleScroll = () => {
            const value = window.scrollY >= minOffset && window.scrollY < document.body.scrollHeight - maxOffset
            setIsInRange(value)
        };
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return [isInRange]
}
function ScrollUpButton() {

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        const firstElement = document.getElementById('desktopLogoHeader')
        if (firstElement) {
            firstElement.focus();
        }
    };

    return (
        <StyledIconWrapper onClick={scrollToTop} aria-label="גלול חזרה לתחילת העמוד">
            <ScrollUpIcon />
        </StyledIconWrapper>
    );
}
export default ScrollUpButton;
